<template>
  <component
    :is="formComponent(question.type)"
    :questionId="questionId"
    :itemObj="itemObj"
    :pageBack="pageBack"
    :focus="focus" />
</template>

<script>
import { mapGetters } from 'vuex'
import RadioElement from './Radio'
import CheckboxElement from './Checkbox'
import NumberGroupElement from './NumberGroup'
import SwitchElement from './Switch'

export default {
  name: 'question',
  dependencies: ['CartElementBuilder'],
  data () {
    return {
    }
  },
  beforeCreate () {
    this.$options.components.RadioElement = RadioElement
    this.$options.components.CheckboxElement = CheckboxElement
    this.$options.components.NumberGroupElement = NumberGroupElement
    this.$options.components.SwitchElement = SwitchElement
  },
  props: {
    questionId: {},
    itemObj: Object,
    pageBack: Boolean,
    focus: Boolean
  },
  computed: {
    ...mapGetters(['currentMenu']),
    question () {
      return this.CartElementBuilder.buildQuestion(this.questionId, this.itemObj, this.currentMenu)
    }
  },
  methods: {
    formComponent: name => name.charAt(0).toUpperCase() + name.slice(1) + 'Element'
  }
}
</script>
